export default __webpack_public_path__ + "static/media/ezice.fdc05ede.png";